__webpack_require__.p = "https://widget.skiportal.bergregions.pl/";